/*
  Sealed product page enhancement script.
  This keeps gallery swaps, variant resolution, quantity sync, and the mobile
  sticky purchase bar scoped to the Sealed detail page while reusing the shared
  Ajax cart flow from theme.js.
*/
(function () {
  function parseProductJson(root) {
    var jsonElement = root.querySelector('[data-sealed-product-json]');

    if (!jsonElement) {
      return null;
    }

    try {
      return JSON.parse(jsonElement.textContent);
    } catch (error) {
      return null;
    }
  }

  function tokenReplace(template, replacements) {
    var output = String(template || '');

    Object.keys(replacements).forEach(function (key) {
      output = output.split('[' + key + ']').join(String(replacements[key]));
    });

    return output;
  }

  function initSealedProduct(root) {
    var productData = parseProductJson(root);
    var mainForm = root.querySelector('[data-sealed-main-form]');
    var cartForms = Array.from(root.querySelectorAll('[data-tcghive-cart-form]'));
    var variantInputs = Array.from(root.querySelectorAll('[data-sealed-variant-id]'));
    var quantityInputs = Array.from(root.querySelectorAll('[data-sealed-quantity-input]'));
    var quantityDisplays = Array.from(root.querySelectorAll('[data-sealed-quantity-display]'));
    var quantityButtons = Array.from(root.querySelectorAll('[data-sealed-quantity-change]'));
    var optionButtons = Array.from(root.querySelectorAll('[data-sealed-option-button]'));
    var wishlistButtons = Array.from(root.querySelectorAll('[data-sealed-wishlist-toggle]'));
    var thumbnailButtons = Array.from(root.querySelectorAll('[data-sealed-thumb]'));
    var mainImage = root.querySelector('[data-sealed-product-main-image]');
    var priceElements = Array.from(root.querySelectorAll('[data-sealed-price], [data-sealed-mobile-price]'));
    var compareElement = root.querySelector('[data-sealed-compare-at]');
    var statusPill = root.querySelector('[data-sealed-status-pill]');
    var availabilityBlock = root.querySelector('[data-sealed-availability-block]');
    var availabilityHeading = root.querySelector('[data-sealed-availability-title]');
    var availabilityTitle = root.querySelector('[data-sealed-availability-title-text]');
    var availabilitySubtitle = root.querySelector('[data-sealed-availability-subtitle]');
    var setValue = root.querySelector('[data-sealed-set-value]');
    var languageFlag = root.querySelector('[data-sealed-language-flag]');
    var languageValue = root.querySelector('[data-sealed-language-label]');
    var factsLanguageFlag = root.querySelector('[data-sealed-facts-language-flag]');
    var conditionValue = root.querySelector('[data-sealed-condition-value]');
    var typeValue = root.querySelector('[data-sealed-type-value]');
    var factsLanguage = root.querySelector('[data-sealed-facts-language-label]');
    var factsCondition = root.querySelector('[data-sealed-facts-condition]');
    var factsType = root.querySelector('[data-sealed-facts-type]');
    var factsSku = root.querySelector('[data-sealed-facts-sku]');
    var submitButtons = Array.from(root.querySelectorAll('[data-sealed-submit], [data-sealed-mobile-submit]'));
    var submitLabels = Array.from(
      root.querySelectorAll('[data-sealed-submit-label], [data-sealed-mobile-submit-label]')
    );
    var wishlistApi = window.TCGHive && window.TCGHive.Wishlist;
    var state = {
      currentVariant: null,
      selection: {},
      optionGroups: productData ? productData.optionGroups : {},
      isPreorder: root.getAttribute('data-is-preorder') === 'true',
      releaseDate: root.getAttribute('data-release-date') || ''
    };

    if (!productData || !mainForm || !variantInputs.length || !quantityInputs.length) {
      return;
    }

    function activeGroups() {
      return ['language', 'condition', 'type'].filter(function (groupKey) {
        return state.optionGroups[groupKey] !== null && state.optionGroups[groupKey] !== '';
      });
    }

    function variantMatchesSelection(variant, selection) {
      return activeGroups().every(function (groupKey) {
        var expectedValue = selection[groupKey];

        if (!expectedValue) {
          return true;
        }

        return String(variant[groupKey + 'Value'] || '') === String(expectedValue);
      });
    }

    function firstPreferredVariant(variants) {
      return (
        variants.find(function (variant) {
          return variant.available;
        }) ||
        variants[0] ||
        null
      );
    }

    function findBestVariant(selection) {
      var exactVariant = productData.variants.find(function (variant) {
        return activeGroups().every(function (groupKey) {
          return String(variant[groupKey + 'Value'] || '') === String(selection[groupKey] || '');
        });
      });

      if (exactVariant) {
        return exactVariant;
      }

      return firstPreferredVariant(
        productData.variants.filter(function (variant) {
          return variantMatchesSelection(variant, selection);
        })
      );
    }

    function setQuantity(nextQuantity) {
      var parsedQuantity = Number(nextQuantity);
      var safeQuantity = Number.isFinite(parsedQuantity) ? parsedQuantity : 1;
      var maxQuantity = getVariantCartMaxQuantity(state.currentVariant);

      if (!state.currentVariant) {
        return;
      }

      safeQuantity = Math.max(1, Math.round(safeQuantity));

      if (maxQuantity !== null) {
        safeQuantity = Math.min(safeQuantity, maxQuantity);
      }

      quantityInputs.forEach(function (quantityInput) {
        quantityInput.value = String(safeQuantity);
      });

      quantityDisplays.forEach(function (quantityDisplay) {
        quantityDisplay.textContent = String(safeQuantity);
      });
    }

    function getVariantCartMaxQuantity(variant) {
      var inventoryMax = Number(variant && variant.inventoryCount);
      var quantityRuleMax = Number(variant && variant.quantityRuleMax);
      var maxQuantity = null;

      if (variant && variant.inventoryTracked && variant.available && Number.isFinite(inventoryMax) && inventoryMax >= 0) {
        maxQuantity = Math.floor(inventoryMax);
      }

      if (Number.isFinite(quantityRuleMax) && quantityRuleMax > 0) {
        quantityRuleMax = Math.floor(quantityRuleMax);
        maxQuantity = maxQuantity === null ? quantityRuleMax : Math.min(maxQuantity, quantityRuleMax);
      }

      return maxQuantity;
    }

    function syncCartMaxQuantity(variant) {
      var maxQuantity = getVariantCartMaxQuantity(variant);

      cartForms.forEach(function (form) {
        if (maxQuantity === null) {
          form.removeAttribute('data-cart-max-quantity');
        } else {
          form.setAttribute('data-cart-max-quantity', String(maxQuantity));
        }
      });
    }

    function syncOptionStates() {
      optionButtons.forEach(function (button) {
        var groupKey = button.getAttribute('data-option-group-key');
        var optionValue = button.getAttribute('data-option-value');
        var nextSelection = Object.assign({}, state.selection);
        var matchingVariants;

        nextSelection[groupKey] = optionValue;
        matchingVariants = productData.variants.filter(function (variant) {
          return variantMatchesSelection(variant, nextSelection);
        });

        button.classList.toggle('is-active', String(state.selection[groupKey] || '') === String(optionValue));
        button.disabled = matchingVariants.length === 0;
        button.classList.toggle('is-disabled', matchingVariants.length === 0);
      });
    }

    function syncAvailability(variant) {
      var statusInStockTemplate = root.getAttribute('data-status-in-stock-template') || '';
      var statusInStockLabel = root.getAttribute('data-status-in-stock-label') || '';
      var statusPreorderLabel = root.getAttribute('data-status-preorder-label') || '';
      var availabilityCountTemplate = root.getAttribute('data-availability-count-template') || '';
      var availabilityInStockLabel = root.getAttribute('data-availability-in-stock-label') || '';
      var availabilityPreorderLabel = root.getAttribute('data-availability-preorder-label') || '';
      var availabilityShipping = root.getAttribute('data-availability-shipping') || '';
      var releaseTemplate = root.getAttribute('data-release-template') || '';
      var soldOutLabel = root.getAttribute('data-label-sold-out') || '';
      var shouldShowReleaseHelper = Boolean(state.isPreorder && state.releaseDate);
      var showAvailabilityBlock = variant.available || shouldShowReleaseHelper;

      if (statusPill) {
        statusPill.classList.remove('is-sold-out', 'is-preorder');

        if (!variant.available) {
          statusPill.textContent = soldOutLabel;
          statusPill.classList.add('is-sold-out');
        } else if (variant.inventoryTracked && variant.inventoryCount > 0) {
          statusPill.textContent = tokenReplace(statusInStockTemplate, {
            count: variant.inventoryCount
          });
        } else if (state.isPreorder) {
          statusPill.textContent = statusPreorderLabel;
          statusPill.classList.add('is-preorder');
        } else {
          statusPill.textContent = statusInStockLabel;
        }
      }

      if (availabilityBlock) {
        availabilityBlock.hidden = !showAvailabilityBlock;
      }

      if (!showAvailabilityBlock) {
        if (availabilityHeading) {
          availabilityHeading.hidden = true;
        }

        if (availabilitySubtitle) {
          availabilitySubtitle.textContent = '';
        }

        return;
      }

      if (availabilityHeading) {
        availabilityHeading.hidden = !variant.available;
      }

      if (availabilityTitle) {
        if (variant.inventoryTracked && variant.inventoryCount > 0) {
          availabilityTitle.textContent = tokenReplace(availabilityCountTemplate, {
            count: variant.inventoryCount
          });
        } else if (state.isPreorder) {
          availabilityTitle.textContent = availabilityPreorderLabel;
        } else {
          availabilityTitle.textContent = availabilityInStockLabel;
        }
      }

      if (availabilitySubtitle) {
        if (variant.available) {
          if (shouldShowReleaseHelper) {
            availabilitySubtitle.textContent = tokenReplace(releaseTemplate, {
              date: state.releaseDate
            });
          } else {
            availabilitySubtitle.textContent = availabilityShipping;
          }
        } else if (shouldShowReleaseHelper) {
          availabilitySubtitle.textContent = tokenReplace(releaseTemplate, {
            date: state.releaseDate
          });
        } else {
          availabilitySubtitle.textContent = '';
        }
      }
    }

    function syncSubmitState(variant) {
      var nextLabel = '';

      if (variant.available) {
        nextLabel = state.isPreorder
          ? root.getAttribute('data-label-preorder') || ''
          : root.getAttribute('data-label-add-to-cart') || '';
      } else {
        nextLabel = root.getAttribute('data-label-sold-out') || '';
      }

      submitButtons.forEach(function (submitButton) {
        submitButton.disabled = !variant.available;
      });

      submitLabels.forEach(function (submitLabel) {
        submitLabel.textContent = nextLabel;
      });
    }

    /*
      Sealed product hearts follow the current selected variant so saved EN and
      DE versions remain separate Wishlist entries.
    */
    function syncWishlistButtons(variant) {
      var baseProductUrl = root.getAttribute('data-product-url-base') || window.location.pathname;
      var productId = root.getAttribute('data-product-id') || '';
      var handle = root.getAttribute('data-product-handle') || '';
      var title = root.getAttribute('data-product-title') || '';
      var setName = root.getAttribute('data-product-set-name') || '';
      var typeLabel = root.getAttribute('data-product-type-label') || '';
      var previewText = root.getAttribute('data-product-preview-text') || '';
      var fallbackImage = root.getAttribute('data-product-fallback-image') || '';
      var productUrl = baseProductUrl;
      var imageUrl = fallbackImage;
      var languageLabel = variant.languageLabel || variant.languageValue || '';
      var conditionLabel = variant.conditionLabel || variant.conditionValue || '';
      var typeValue = variant.typeLabel || variant.typeValue || typeLabel;
      var maxQuantity = getVariantCartMaxQuantity(variant);

      if (!wishlistButtons.length || !variant) {
        return;
      }

      if (variant.id) {
        productUrl = baseProductUrl + '?variant=' + variant.id;
      }

      if (variant.imageSrc) {
        imageUrl = variant.imageSrc;
      }

      wishlistButtons.forEach(function (button) {
        button.setAttribute('data-wishlist-product-id', productId);
        button.setAttribute('data-wishlist-variant-id', String(variant.id || ''));
        button.setAttribute('data-wishlist-handle', handle);
        button.setAttribute('data-wishlist-kind', 'sealed');
        button.setAttribute('data-wishlist-title', title);
        button.setAttribute('data-wishlist-product-url', productUrl);
        button.setAttribute('data-wishlist-image', imageUrl);
        button.setAttribute('data-wishlist-set-name', setName);
        button.setAttribute('data-wishlist-language', languageLabel);
        button.setAttribute('data-wishlist-condition', conditionLabel);
        button.setAttribute('data-wishlist-type-label', typeValue);
        button.setAttribute('data-wishlist-preview-text', previewText);

        if (maxQuantity === null) {
          button.removeAttribute('data-wishlist-cart-max-quantity');
        } else {
          button.setAttribute('data-wishlist-cart-max-quantity', String(maxQuantity));
        }
      });

      if (wishlistApi && typeof wishlistApi.refreshUI === 'function') {
        wishlistApi.refreshUI(root);
      }
    }

    function syncVariant(variant) {
      if (!variant) {
        return;
      }

      state.currentVariant = variant;
      state.selection.language = variant.languageValue || null;
      state.selection.condition = variant.conditionValue || null;
      state.selection.type = variant.typeValue || null;

      variantInputs.forEach(function (variantInput) {
        variantInput.value = String(variant.id);
      });

      cartForms.forEach(function (form) {
        form.setAttribute('data-variant-summary', variant.summary || '');
      });
      syncCartMaxQuantity(variant);

      priceElements.forEach(function (priceElement) {
        priceElement.textContent = variant.priceFormatted || '';
      });

      if (compareElement) {
        if (variant.compareAtFormatted) {
          compareElement.textContent = variant.compareAtFormatted;
          compareElement.hidden = false;
        } else {
          compareElement.textContent = '';
          compareElement.hidden = true;
        }
      }

      if (languageValue && variant.languageLabel) {
        languageValue.textContent = variant.languageLabel;
      }

      if (languageFlag && typeof variant.languageFlagHtml === 'string') {
        languageFlag.innerHTML = variant.languageFlagHtml;
      }

      if (conditionValue && variant.conditionLabel) {
        conditionValue.textContent = variant.conditionLabel;
      }

      if (typeValue && variant.typeLabel) {
        typeValue.textContent = variant.typeLabel;
      }

      if (factsLanguage && variant.languageLabel) {
        factsLanguage.textContent = variant.languageLabel;
      }

      if (factsLanguageFlag && typeof variant.languageFlagHtml === 'string') {
        factsLanguageFlag.innerHTML = variant.languageFlagHtml;
      }

      if (factsCondition && variant.conditionLabel) {
        factsCondition.textContent = variant.conditionLabel;
      }

      if (factsType && variant.typeLabel) {
        factsType.textContent = variant.typeLabel;
      }

      if (factsSku) {
        factsSku.textContent = variant.sku || '';
      }

      if (mainImage && variant.imageSrc) {
        mainImage.src = variant.imageSrc;
        mainImage.alt = variant.imageAlt || '';
      }

      syncAvailability(variant);
      syncSubmitState(variant);
      syncWishlistButtons(variant);
      syncOptionStates();
      setQuantity(quantityInputs[0].value || 1);
    }

    function bindThumbnails() {
      if (!mainImage || !thumbnailButtons.length) {
        return;
      }

      thumbnailButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var imageSrc = button.getAttribute('data-image-src');
          var imageAlt = button.getAttribute('data-image-alt') || '';

          if (!imageSrc) {
            return;
          }

          mainImage.src = imageSrc;
          mainImage.alt = imageAlt;

          thumbnailButtons.forEach(function (thumbButton) {
            thumbButton.classList.remove('is-active');
          });

          button.classList.add('is-active');
        });
      });
    }

    function bindQuantities() {
      quantityButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var delta = Number(button.getAttribute('data-sealed-quantity-change') || 0);
          var currentQuantity = Number(quantityInputs[0].value || 1);
          setQuantity(currentQuantity + delta);
        });
      });
    }

    function bindOptions() {
      optionButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var groupKey = button.getAttribute('data-option-group-key');
          var optionValue = button.getAttribute('data-option-value');
          var nextSelection = Object.assign({}, state.selection);
          var nextVariant;

          if (!groupKey || !optionValue || button.disabled) {
            return;
          }

          nextSelection[groupKey] = optionValue;
          nextVariant = findBestVariant(nextSelection);

          if (nextVariant) {
            syncVariant(nextVariant);
          }
        });
      });
    }

    bindThumbnails();
    bindQuantities();
    bindOptions();

    syncVariant(firstPreferredVariant(productData.variants));
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-sealed-product-root]').forEach(function (root) {
      initSealedProduct(root);
    });
  });
})();
